import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ZoomIconSvg() {
  return (
    <svg
      width="33"
      height="33"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="enhancedShadow"
          x="-5"
          y="-5"
          width="51"
          height="51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dx="2" dy="2" stdDeviation="3" floodColor="#00000080" />
        </filter>
      </defs>
      <g filter="url(#enhancedShadow)">
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.2954 21.2954C25.6892 20.9015 26.3277 20.9015 26.7215 21.2954L34.9831 29.5569V23.9746C34.9831 23.4177 35.4346 22.9662 35.9916 22.9662C36.5485 22.9662 37 23.4177 37 23.9746V31.9916C37 32.5485 36.5485 33 35.9916 33H27.9747C27.4178 33 26.9663 32.5485 26.9663 31.9915C26.9663 31.4346 27.4178 30.9831 27.9747 30.9831H33.5569L25.2954 22.7215C24.9015 22.3277 24.9015 21.6892 25.2954 21.2954Z"
            fill="#DFE4E5"
          />
        </g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.2954 11.7046C25.6892 12.0985 26.3277 12.0985 26.7215 11.7046L34.9831 3.44305V9.02535C34.9831 9.5823 35.4346 10.0338 35.9916 10.0338C36.5485 10.0338 37 9.5823 37 9.02535V1.00845C37 0.451498 36.5485 0 35.9916 0H27.9747C27.4178 0 26.9663 0.451504 26.9663 1.00845C26.9663 1.5654 27.4178 2.0169 27.9747 2.0169H33.5569L25.2954 10.2785C24.9015 10.6723 24.9015 11.3108 25.2954 11.7046Z"
            fill="#DFE4E5"
          />
        </g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7046 11.7046C15.3108 12.0985 14.6723 12.0985 14.2785 11.7046L6.01689 3.44305V9.02535C6.0169 9.5823 5.5654 10.0338 5.00845 10.0338C4.4515 10.0338 4 9.5823 4 9.02535V1.00845C4 0.451498 4.4515 0 5.00845 0H13.0253C13.5822 0 14.0337 0.451504 14.0337 1.00845C14.0337 1.5654 13.5822 2.0169 13.0253 2.0169H7.44305L15.7046 10.2785C16.0985 10.6723 16.0985 11.3108 15.7046 11.7046Z"
            fill="#DFE4E5"
          />
        </g>
        {/* New arrow at bottom-left */}
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7046 21.2954C15.3108 21.6892 15.3108 22.3277 15.7046 22.7215L7.44305 30.9831H13.0253C13.5822 30.9831 14.0337 31.4346 14.0337 31.9915C14.0337 32.5485 13.5822 33 13.0253 33H5.00845C4.4515 33 4 32.5485 4 31.9916V23.9747C4 23.4178 4.4515 22.9663 5.00845 22.9663C5.5654 22.9663 6.0169 23.4178 6.0169 23.9747V29.5569L14.2785 21.2954C14.6723 20.9015 15.3108 20.9015 15.7046 21.2954Z"
            fill="#DFE4E5"
          />
        </g>
      </g>
    </svg>
  )
}

export default function ZoomIcon(props: Partial<CustomIconComponentProps>) {
  return <Icon component={ZoomIconSvg} {...props} />
}
